import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import SideBar from '../../components/organisms/SideBar';
import { Loading } from '../../components/molecules/Loading';
import Route from '../../routes';
import { AppBar } from '../../components/molecules/AppBar';
import Alert from '../../components/molecules/Alert';
import { menuState } from '../../redux/actions/menuActions';

const useStyles = makeStyles({
    root: () => ({
        display: 'flex'
    }),
    drawerHeader: ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end'
    }),
    content: ({ theme, drawerWidth }) => ({
        width: '100%',
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        marginLeft: 0,
        [theme.breakpoints.up('md')]: {
            marginLeft: -drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
        },

    }),
    contentFullScreen: ({ theme, drawerWidth }) => ({
        width: '100%',
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        marginLeft: 0,
        [theme.breakpoints.up('xl')]: {
            marginLeft: -drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
        },

    }),
    contentShift: ({ theme, drawerWidth }) => ({
        width: '100%',
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`
        }
    }),
    contentShiftFullScreen: ({ theme, drawerWidth }) => ({
        width: '100%',
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        [theme.breakpoints.up('xl')]: {
            width: `calc(100% - ${drawerWidth}px)`
        }
    })
});

const PaginaPadrao = () => {
    const open = useSelector(state => state.menu.open);
    const drawerWidth = useSelector(state => state.menu.largura);
    const theme = useTheme();
    const classes = useStyles({
        theme,
        drawerWidth
    });
    const dispatch = useDispatch();
    const apiCallsInProgress = useSelector(state => state.apiCallsInProgress);
    const login = useSelector(state => state.login);
    let user = login.role;
    const matches = useMediaQuery(login.token && (user === 'AGENTE_CO' || user === 'AGENTE_CRV') ? theme.breakpoints.up('xl') : theme.breakpoints.up('md'));
    let varient = 'persistent';
    if (!matches) {
        varient = 'temporary';
    }
    useEffect(() => {
        if (!matches) {
            dispatch(menuState(false));
        } else {
            dispatch(menuState(true));
        }
    }, [dispatch, matches]);

    const handleDrawerOpen = () => {
        dispatch(menuState(true));
    };

    const handleDrawerClose = () => {
        dispatch(menuState(false));
    };

    return (
        <div className={classes.root}>
            <Loading open={apiCallsInProgress !== 0} />
            <Alert />
            {login.token && (
                <div>
                    <CssBaseline />
                    <SideBar
                        permissoes={login.permissoes}
                        nomeUsuario={login.nome}
                        isOpen={open}
                        close={handleDrawerClose}
                        matches={matches}
                        varient={varient}
                        drawerWidth={drawerWidth}
                    />
                </div>
            )}
            {(login.role === 'AGENTE_CO' || login.role === 'AGENTE_CRV') ? (
                <main
                    className={clsx(classes.contentFullScreen, {
                        [classes.contentShiftFullScreen]: open
                    })}
                >
                    {login.token && (
                        <div>
                            <CssBaseline />
                            <AppBar
                                drawerWidth={drawerWidth}
                                handleDrawerOpen={handleDrawerOpen}
                                menuOpen={open}
                            />
                        </div>
                    )}

                    <Route />
                </main>
            ) : (
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: open
                    })}
                >
                    {login.token && (
                        <div>
                            <CssBaseline />
                            <AppBar
                                drawerWidth={drawerWidth}
                                handleDrawerOpen={handleDrawerOpen}
                                menuOpen={open}
                            />
                        </div>
                    )}

                    <Route />
                </main>
            )}

        </div>
    );
};

export default PaginaPadrao;
